import { render, staticRenderFns } from "./PastPerformance.vue?vue&type=template&id=135da459&"
import script from "./PastPerformance.vue?vue&type=script&lang=js&"
export * from "./PastPerformance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports